import { render, staticRenderFns } from "./bank-books-normatives.vue?vue&type=template&id=5c1c9fff&lang=pug&"
import script from "./bank-books-normatives.vue?vue&type=script&lang=js&"
export * from "./bank-books-normatives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports